import Sidebar from "../Sidebar";
import { Stack } from "@mui/material";
import LiveMapView from "./LiveMapView";

const index = () => {
  return (
    <Stack>
      <Stack direction="row" sx={{ width: "100%", backgroundColor: "#E5E5E5", height: "100%" }}>
        <Sidebar />
        <LiveMapView/>
      </Stack>      
      
    </Stack>
  );
};

export default index;